import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDateRangePicker, MAT_DATE_RANGE_SELECTION_STRATEGY } from '@angular/material/datepicker';
import { DTypeFormControl, DTypeFormDateRangeField } from '@grupo-constant/next-dtype/form';
import { DateRangepicker, DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { formatISO } from 'date-fns';
import { CustomRangeSelectionStrategy, DateFormat } from '../../dtype-date';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'daterangepicker-field-component',
    templateUrl: './daterangepicker-field.component.html',
    providers: [
        { provide: MAT_DATE_FORMATS, useClass: DateFormat },
        { provide: MAT_DATE_RANGE_SELECTION_STRATEGY, useClass: CustomRangeSelectionStrategy }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DtypeDaterangepickerFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormDateRangeField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;

    min: Date;
    max: Date;

    startDateControl: DTypeFormControl;
    endDateControl: DTypeFormControl;

    constructor(
        @Inject(MAT_DATE_FORMATS) private dateFormat: DateFormat,
        @Inject(MAT_DATE_RANGE_SELECTION_STRATEGY) private selectionStrategy: CustomRangeSelectionStrategy<Date>,
    ) { }

    ngOnInit() {
        if (this.field.min) {
            this.min = new Date(this.field.min);
        }
        if (this.field.max) {
            this.max = new Date(this.field.max);
        }

        this.dateFormat.style = (this.field.dTypeCol as DateRangepicker).style;
        this.selectionStrategy.days = (this.field.dTypeCol as DateRangepicker).fixedDaysInRange ?? 0;

        this.startDateControl = (this.field.control.get('from') as DTypeFormControl);
        this.endDateControl = (this.field.control.get('to') as DTypeFormControl);

        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

    dateChange(event: any, date: 'from' | 'to') {
        const control = date === 'from' ? this.startDateControl : this.endDateControl;
        control.setValue(event.value ? formatISO(Date.parse(String(event.value)), { representation: 'date' }) : '');
    }

    openDatepickerOnClick(datepicker: MatDateRangePicker<Date>) {
        if (!datepicker.opened) {
            datepicker.open();
        }
    }

}
